import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ScrollService {
  private _preserveNext = false;

  preserveNextNavigation(): void {
    this._preserveNext = true;
  }

  consumePreserve(): boolean {
    const value = this._preserveNext;
    this._preserveNext = false;
    return value;
  }
}
